// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionsRender__container___TSLlF {
    display: flex;
    flex-direction: row;
    gap: var(--space-xs);
}

.ActionsRender__actionsContainer___mmK9X {
    display: flex;
    flex-direction: row;
    gap: var(--space-xs);
    align-items: center;
    justify-content: center;

    min-height: 3.4rem;
    padding-inline: var(--space-2xs);

    background-color: var(--color-bg-default);
    border: var(--control-border-width) solid var(--color-bg-border);
    border-radius: calc(2 * var(--control-radius));

    transition: all 0.3s cubic-bezier(0.87, 0, 0.15, 1);

    &.ActionsRender__selected___fI51h {
        padding-inline: unset;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/model/Actions/ActionsRender.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB,kBAAkB;IAClB,gCAAgC;;IAEhC,yCAAyC;IACzC,gEAAgE;IAChE,8CAA8C;;IAE9C,mDAAmD;;IAEnD;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    gap: var(--space-xs);\n}\n\n.actionsContainer {\n    display: flex;\n    flex-direction: row;\n    gap: var(--space-xs);\n    align-items: center;\n    justify-content: center;\n\n    min-height: 3.4rem;\n    padding-inline: var(--space-2xs);\n\n    background-color: var(--color-bg-default);\n    border: var(--control-border-width) solid var(--color-bg-border);\n    border-radius: calc(2 * var(--control-radius));\n\n    transition: all 0.3s cubic-bezier(0.87, 0, 0.15, 1);\n\n    &.selected {\n        padding-inline: unset;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ActionsRender__container___TSLlF`,
	"actionsContainer": `ActionsRender__actionsContainer___mmK9X`,
	"selected": `ActionsRender__selected___fI51h`
};
export default ___CSS_LOADER_EXPORT___;
